var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',{attrs:{"title":"Absenzenwesen","color":"info"}},[_c('v-btn',{attrs:{"color":"success","fab":"","fixed":"","bottom":"","right":"","to":{ name: 'JustificationStudentEdit', params: { justificationId: 0 } }}},[_c('v-icon',[_vm._v("mdi-plus")])],1),_c('Student',{attrs:{"id":_vm.$_profilePerson.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }